import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { MessageService } from 'primeng/api';

// Pipes
import { TruncateCharactersPipe } from './pipes/truncate.pipe';
import { UppercaseFirstLetterPipe } from './pipes/uppercase-first-letter.pipe';
import { SortByPipe } from './pipes/sort.pipe';
import { ToFloorPipe } from './pipes/to-floor.pipe';
import { FilterCurrencyPipe } from './pipes/filter-currency.pipe';
import { ProjectFundNumberPipe } from './pipes/project-fund-number.pipe';
import { SafeHTMLPipe } from './pipes/safe-html.pipe';
import { TranslateCutPipe } from './pipes/translate-cut.pipe';
import { ToSnakeCasePipe } from './pipes/to-snake-case.pipe';
import { SnakeCaseToDottedPipe } from './pipes/snake-case-to-dotted.pipe';
import { TransformPipe } from './pipes/transform.pipe';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { FundNameFormatPipe } from './pipes/fund-name-format.pipe';
import { EnumToArrayPipe } from './pipes/enum-to-array.pipe';

// Directives
import { FormatTextDirective } from './directives/format-text.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';

// Components
import { RecurringFormComponent } from './recurring-form/recurring-form.component';
import { AutocompleteFieldComponent } from './components/autocomplete-field/autocomplete-field.component';
import { CountrySelectorComponent } from './components/country-selector/country-selector.component';
import { CharitySelectorComponent } from './components/charity-selector/charity-selector.component';
import { ToastComponent } from './components/toast/toast.component';
import { RedirectConfirmationDialogComponent } from './components/redirect-confirmation-dialog/redirect-confirmation-dialog.component';

// Services
import { PortalToastService } from './services/portal-toast.service';

// External pipes
import { TranslateLangPipe } from '@gs-2.0/shared';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PaginationModule.forRoot(),
    TranslateLangPipe,
    // Pipes
    TruncateCharactersPipe,
    UppercaseFirstLetterPipe,
    SortByPipe,
    ToFloorPipe,
    FilterCurrencyPipe,
    ProjectFundNumberPipe,
    SafeHTMLPipe,
    TranslateCutPipe,
    ToSnakeCasePipe,
    SnakeCaseToDottedPipe,
    TransformPipe,
    NumberFormatPipe,
    FundNameFormatPipe,
    EnumToArrayPipe,
    // Directives
    FormatTextDirective,
    ClickOutsideDirective,
    // Components
    RecurringFormComponent,
    AutocompleteFieldComponent,
    CountrySelectorComponent,
    CharitySelectorComponent,
    ToastComponent,
    RedirectConfirmationDialogComponent,
  ],
  declarations: [],
  providers: [MessageService, PortalToastService],
  exports: [
    // Angular modules
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PaginationModule,
    TranslateLangPipe,
    // Pipes
    TruncateCharactersPipe,
    UppercaseFirstLetterPipe,
    SortByPipe,
    ToFloorPipe,
    FilterCurrencyPipe,
    ProjectFundNumberPipe,
    SafeHTMLPipe,
    TranslateCutPipe,
    ToSnakeCasePipe,
    SnakeCaseToDottedPipe,
    TransformPipe,
    NumberFormatPipe,
    FundNameFormatPipe,
    EnumToArrayPipe,
    // Directives
    FormatTextDirective,
    ClickOutsideDirective,
    // Components
    RecurringFormComponent,
    AutocompleteFieldComponent,
    CountrySelectorComponent,
    CharitySelectorComponent,
    ToastComponent,
    RedirectConfirmationDialogComponent,
  ],
})
export class PortalSharedModule {}
